import React from 'react';
import { Typography, Box, SvgIcon, Link } from '@mui/material';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';
import { appContext } from '../../../../../AppContext';
import IbssDrawer from '../../../../../Components/Drawer/IbssDrawer';
import CloseIcon from '../../../../../Components/Icons/CloseIcon';
import GearIcon from '../../../../../Components/Icons/GearIcon';
import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import IbssInputDropDown from '../../../../../Components/Inputs/SelectList/IbssInputDropDown';
import IbssSwitchLabel from '../../../../../Components/Inputs/Switch/IbssSwitchLabel';
import IbssButton from '../../../../../Components/Buttons/Button/IbssButton';
import MediaSelector from '../../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import { IEquipment } from './ListEquipments';

class EditEquipmentDrawer extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; };
    private equipmentCategoryList: IDropDownOption[];
    private equipmentTypeList: IDropDownOption[];
    private equipmentClassList: IDropDownOption[];

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            isLoading: false,
            equipmentID: "",
            assignedToEquipmentStore: "",
            imageUrl: "",
            equipmentName: "",
            equipmentClass: "",
            equipmentType: "",
            equipmentIsEnabled: false,
            equipmentTagNumber: "",
            equipmentSerialNumber: "",
            equipmentSpaceID: "",
            equipmentStatus: "",
            isDuplicated: false,
            equipmentCategory: '',
            categoryList: [],
            equipmentTypeList: [],
            equipmentClassList: []

        };
        this.equipmentTypeList = [
            { label: this.labels.HubLabelAHU, value: EquipmentType.AHU },
            { label: this.labels.HubLabelCAV, value: EquipmentType.CAV },
            { label: this.labels.HubLabelVAV, value: EquipmentType.VAV },
            { label: this.labels.HubLabelSF, value: EquipmentType.SF },
            { label: this.labels.HubLabelEF, value: EquipmentType.EF },
            { label: this.labels.HubLabelTef, value: EquipmentType.TEF },
            { label: this.labels.HubLabelPumpSet, value: EquipmentType.PumpSet },
            { label: this.labels.HubLabelPump, value: EquipmentType.Pump },
            { label: this.labels.HubLabelphe, value: EquipmentType.PHE },
            { label: this.labels.HubLabelThermalStore, value: EquipmentType.ThermalStore },
            { label: this.labels.HubLabelHeatPump, value: EquipmentType.HeatPump },
            { label: this.labels.HubLabelBoiler, value: EquipmentType.Boiler },
            { label: this.labels.HubLabelCalorifier, value: EquipmentType.Calorifier },
            { label: this.labels.HubLabelChiller, value: EquipmentType.Chiller },
            { label: this.labels.HubLabelCoolingTower, value: EquipmentType.CoolingTower },
            { label: this.labels.HubLabelpu, value: EquipmentType.PU },
            { label: this.labels.HubLabelfcu, value: EquipmentType.FCU },
            { label: this.labels.HubLabelAirCurtain, value: EquipmentType.AirCurtain },
            { label: this.labels.HubLabeltrenchHeater, value: EquipmentType.TrenchHeater },
            { label: this.labels.HubLabelGenerator, value: EquipmentType.Generator },
            { label: this.labels.HubLabelchp, value: EquipmentType.CHP },
            { label: this.labels.HubLabelups, value: EquipmentType.UPS },
            { label: this.labels.HubLabelController, value: EquipmentType.Controller },
            { label: this.labels.HubLabelElectricMeter, value: EquipmentType.ElectricMeter },
            { label: this.labels.HubLabelThermalMeter, value: EquipmentType.ThermalMeter },
            { label: this.labels.HubLabelGasMeter, value: EquipmentType.GasMeter },
            { label: this.labels.HubLabelWaterMeter, value: EquipmentType.WaterMeter },
            { label: this.labels.HubLabelFireExtinguisher, value: EquipmentType.FireExtinguisher },
            { label: this.labels.HubLabelCallPoint, value: EquipmentType.CallPoint },
            { label: this.labels.HubLabelSmokeDetector, value: EquipmentType.SmokeDetector },
            { label: this.labels.HubLabelHeatDetector, value: EquipmentType.HeatDetector },
            { label: this.labels.HubLabelVisualAndSounder, value: EquipmentType.VisualAndSounder },
            { label: this.labels.HubLabelFireAlarmPanel, value: EquipmentType.FireAlarmPanel },
            { label: this.labels.HubLabelOutdoorUnit, value: EquipmentType.OutdoorUnit },
            { label: this.labels.HubLabelIndoorUnit, value: EquipmentType.IndoorUnit },
            { label: this.labels.HubLabelPresentationAid, value: EquipmentType.PresentationAid },
            { label: this.labels.HubLabelHearingAid, value: EquipmentType.HearingAid },
            { label: this.labels.HubLabelDisplayScreen, value: EquipmentType.DisplayScreen },
            { label: this.labels.HubLabelCoffeeMachine, value: EquipmentType.CoffeeMachine },
        ];
        this.equipmentClassList = [
            { label: this.labels.funcVentilation_S, value: EquipmentClass.Ventilation },
            { label: this.labels.funcLabelLTHW_S, value: EquipmentClass.LTHW },
            { label: this.labels.funcLabelHWS_S, value: EquipmentClass.HWS },
            { label: this.labels.funcLabelCHW_S, value: EquipmentClass.CHW },
            { label: this.labels.funcTerminalUnits_S, value: EquipmentClass.TerminalUnits },
            { label: this.labels.funcElectrical_S, value: EquipmentClass.Electrical },
            { label: this.labels.funcControllers_S, value: EquipmentClass.Controllers },
            { label: this.labels.funcLabelCWS_S, value: EquipmentClass.CWS },
            { label: this.labels.funcMeters_S, value: EquipmentClass.Meters },
            { label: this.labels.funcFireProtection_S, value: EquipmentClass.FireProtection },
            { label: this.labels.funcLabelAC_S, value: EquipmentClass.AC },
            { label: this.labels.HubMenuWorkplace, value: EquipmentClass.Workplace },
        ];
        this.equipmentCategoryList = [
            { label: this.labels.funcCapitalPlant_S, value: EquipmentCategory.CapitalPlant },
            { label: this.labels.HubMenuWorkplace, value: EquipmentCategory.Workplace },
        ];
    }

    public async componentDidUpdate(prevProps: IProps, prevState: IState): Promise<void>
    {
        if (prevProps.isEditMode !== this.props.isEditMode) 
        {
            if (this.props.isEditMode) 
            {
                this.populateEquipmentDetails();
            }
        }
    };

    private async populateEquipmentDetails(): Promise<void> 
    {
        const { selectedEquipment } = this.props;

        this.setState({
            equipmentID: selectedEquipment.id,
            assignedToEquipmentStore: selectedEquipment.storeSpaceId,
            imageUrl: selectedEquipment.imageUrl,
            equipmentName: selectedEquipment.equipmentName,
            equipmentClass: selectedEquipment.equipmentClass,
            equipmentType: selectedEquipment.equipmentType,
            equipmentIsEnabled: selectedEquipment.isEquipmentEnabled,
            equipmentTagNumber: selectedEquipment.equipmentTagNo,
            equipmentSerialNumber: selectedEquipment.equipmentSerialNo,
            equipmentSpaceID: selectedEquipment.storeSpaceId,
            equipmentStatus: selectedEquipment.equipmentStatusInfo,
            equipmentCategory: selectedEquipment.equipmentCategory,
        });

    }

    private async uploadImage(filename: string, file: FormData, processAsMap: boolean): Promise<void>
    {
        try 
        {
            this.setState({ isLoading: true });
            await appContext().webEntryApiClientV1.api.webentry.v1.file.byPath.post({
                path: 'c/Equipment/' + filename,
                processAsMapFile: processAsMap,
                body: file
            });
            this.props.getImages();
        }
        finally 
        {
            this.setState({ isLoading: false });
        }
    }

    private handleDuplicateClick(): void
    {
        if (this.props.isEditMode && !this.state.isDuplicated) 
        {
            const savedEquipment = {
                equipmentID: '',
                assignedToEquipmentStore: this.state.assignedToEquipmentStore,
                imageUrl: this.state.imageUrl,
                equipmentName: `Copy of ${this.state.equipmentName}`,
                equipmentClass: this.state.equipmentClass,
                equipmentType: this.state.equipmentType,
                equipmentIsEnabled: this.state.equipmentIsEnabled,
                equipmentTagNumber: this.state.equipmentTagNumber,
                equipmentSerialNumber: this.state.equipmentSerialNumber,
                equipmentSpaceID: this.state.equipmentSpaceID,
                equipmentStatus: this.state.equipmentStatus,
                equipmentCategory: this.state.equipmentCategory,
            };
            this.setState({ ...savedEquipment, isDuplicated: true });
        }
    }

    private getInitialState(): void
    {
        this.setState({
            equipmentID: "",
            assignedToEquipmentStore: "",
            imageUrl: "",
            equipmentName: "",
            equipmentClass: "",
            equipmentType: "",
            equipmentIsEnabled: false,
            equipmentTagNumber: "",
            equipmentSerialNumber: "",
            equipmentSpaceID: "",
            equipmentStatus: "",
            equipmentCategory: "",
            isDuplicated: false
        })
    }

    private async handleSaveClick(): Promise<void>
    {
        this.setState({ isLoading: true });
        const payload = {
            Equip_Id: (this.state.isDuplicated || !this.props.isEditMode) ? undefined : this.state.equipmentID,
            Store_Space_Id: this.state.assignedToEquipmentStore,
            ImageURI: this.state.imageUrl,
            Equip_Name: this.state.equipmentName,
            Equip_Class: this.state.equipmentClass,
            Equip_Type: this.state.equipmentType,
            Equip_IsEnabled: this.state.equipmentIsEnabled ? 1 : 0,
            Equip_Tag_No: this.state.equipmentTagNumber,
            Equip_Serial_No: this.state.equipmentSerialNumber,
            Equip_Status: this.state.equipmentStatus,
            Equip_Category: this.state.equipmentCategory,
        };

        try
        {
            if (this.props.isEditMode && !this.state.isDuplicated)
            {
                await appContext().ibssApiClientV2.v2.byNodeid.equipment.byEquipid.put({
                    nodeId: this.props.buildingId,
                    equipid: this.state.equipmentID,
                    body: payload
                })
            }
            else
            {
                await appContext().ibssApiClientV2.v2.byNodeid.equipment.post({
                    nodeId: this.props.buildingId,
                    body: payload
                })
            }

            this.setState({ isLoading: false });
            this.props.loadEquipmentList();
            this.closeDrawer();
        }
        catch 
        {
            this.setState({ isLoading: false });
        }
    }

    private closeDrawer(): void
    {
        this.props.onClose();
        this.getInitialState();
    }

    public render(): JSX.Element
    {
        const formFieldsValid = this.state.equipmentName !== "" && this.state.assignedToEquipmentStore !== "" && this.state.equipmentClass !== "" && this.state.equipmentType !== "" && this.state.equipmentCategory !== "";
        return (
            <IbssDrawer open={this.props.open} onClose={() => this.closeDrawer()} anchor='right' className='flex-search-filter-criteria' sx={{ backgroundColor: "var(--ui-background-alternate)" }}>
                <Box className="tablePanel" p={3}>
                    <Box display={"flex"} sx={{ cursor: "pointer" }} justifyContent={"flex-end"} >
                        <SvgIcon onClick={() => this.closeDrawer()}>
                            <CloseIcon />
                        </SvgIcon>
                    </Box>
                    <Typography variant="h5">{this.labels.funcManageEquipment_L}</Typography>
                    <Box display={"flex"} justifyContent={"space-between"} my={1}>
                        <Typography variant="body1" color="textSecondary" sx={{ mt: 1 }}>{this.labels.funcManageEquipmentSubheading_D}</Typography>
                        {this.props.isEditMode &&
                            <Link component="button" sx={{ cursor: "pointer" }} disabled={this.state.isDuplicated}>
                                <Box display="flex" justifyContent={"flex-end"} alignItems="center" onClick={() => { this.handleDuplicateClick() }}>
                                    <SvgIcon>
                                        <GearIcon />
                                    </SvgIcon>
                                    {this.labels.funcDuplicate}
                                </Box>
                            </Link>
                        }
                    </Box>
                    <hr />
                    <Box my={1}>
                        {this.props.isEditMode &&
                            <IbssTextField
                                disabled
                                fullWidth
                                label={this.labels.HubLabelEquipmentId}
                                value={this.state.equipmentID}
                                margin="normal"
                            />
                        }
                        <IbssInputDropDown
                            id="equipmentStore"
                            inputLabel={this.labels.funcAssignedEquipmentStore_S}
                            required
                            options={this.props.storeList}
                            value={this.state.assignedToEquipmentStore}
                            onChange={(e) => this.setState({ assignedToEquipmentStore: e.target.value })}
                        />
                        <Box my={1}>
                            <Typography variant="h6" fontWeight={'normal'} mb={1}>{this.labels.funcChooseImage_S}</Typography>
                            <Typography variant="body1" className="ui-text-light">{this.labels.funcUploadAnIconInfo_D}</Typography>
                        </Box>
                        <Box className="option-box" my={1}>
                            <Box mt={1} display={'flex'} justifyContent={"space-between"}>
                                <MediaSelector
                                    options={this.props.images.map(i => ({ name: i.name, url: i.path }))}
                                    imageSelected={file => this.setState({ imageUrl: file.url })}
                                    uploadFile={(filename, file, processAsMap) => this.uploadImage(filename, file, processAsMap)}
                                    defaultSelectedImage={this.state.imageUrl}
                                />
                            </Box>
                        </Box>

                        <IbssTextField
                            fullWidth
                            required
                            label={this.labels.funcEquipmentName_S}
                            value={this.state.equipmentName}
                            onChange={(e) => this.setState({ equipmentName: e.target.value })}
                            margin="normal"
                        />
                        <Box display={"flex"} flexDirection={"column"} gap={2}>
                            <IbssInputDropDown
                                id="equipmentClass"
                                inputLabel={this.labels.funcEquipmentClass_S}
                                required
                                options={this.equipmentClassList}
                                value={this.state.equipmentClass}
                                onChange={(e) => this.setState({ equipmentClass: e.target.value })}
                            />
                            <IbssInputDropDown
                                id="equipmentType"
                                inputLabel={this.labels.HubLabelEquipmentType}
                                required
                                options={this.equipmentTypeList}
                                value={this.state.equipmentType}
                                onChange={(e) => this.setState({ equipmentType: e.target.value })}
                            />
                            <IbssInputDropDown
                                id="equipmentCategory"
                                inputLabel={this.labels.funcEquipmentCategory_S}
                                required
                                options={this.equipmentCategoryList}
                                value={this.state.equipmentCategory}
                                onChange={(e) => this.setState({ equipmentCategory: e.target.value })}
                            />
                        </Box>
                        <IbssSwitchLabel
                            checked={this.state.equipmentIsEnabled}
                            onChange={e => this.setState({ equipmentIsEnabled: e.target.checked })}
                            label={this.labels.funcEquipmentEnabled_S}
                        />
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcEquipmentTagNumber_S}
                            value={this.state.equipmentTagNumber}
                            onChange={(e) => this.setState({ equipmentTagNumber: e.target.value })}
                            margin="normal"
                        />
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcEquipmentSerialNumber_S}
                            value={this.state.equipmentSerialNumber}
                            onChange={(e) => this.setState({ equipmentSerialNumber: e.target.value })}
                            margin="normal"
                        />
                        {this.props.isEditMode &&
                            <IbssTextField
                                fullWidth
                                disabled
                                label={this.labels.funcEquipmentSpaceID_S}
                                value={this.state.equipmentSpaceID}
                                margin="normal"
                            />
                        }
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcEquipmentStatus_S}
                            value={this.state.equipmentStatus}
                            onChange={(e) => this.setState({ equipmentStatus: e.target.value })}
                            margin="normal"
                        />

                        <Box display="flex" alignItems="center" gap={2}>
                            <IbssButton
                                variant="contained"
                                color="secondary"
                                onClick={() => this.closeDrawer()}
                            >
                                {this.labels.HubButtonCancel}
                            </IbssButton>
                            <IbssButton
                                variant="contained"
                                color="primary"
                                disabled={!formFieldsValid}
                                onClick={() => this.handleSaveClick()}
                            >
                                {(this.props.isEditMode && !this.state.isDuplicated) ? this.labels.HubLabelUpdate : this.labels.HubButtonSave}
                            </IbssButton>
                        </Box>
                    </Box>
                </Box>
            </IbssDrawer>
        );
    }
}

export default EditEquipmentDrawer;

export interface IProps
{
    open: boolean;
    selectedEquipment: IEquipment;
    buildingId: number;
    storeList: Array<IListOption<string>>;
    images: IFile[];
    getImages: () => void;
    onClose: () => void;
    loadEquipmentList: () => void;
    isEditMode: boolean;
}

export interface IState
{
    isLoading: boolean;
    equipmentID: string;
    assignedToEquipmentStore: string;
    imageUrl: string;
    equipmentName: string;
    equipmentClass: string;
    equipmentType: string;
    equipmentIsEnabled: boolean;
    equipmentTagNumber: string;
    equipmentSerialNumber: string;
    equipmentSpaceID: string;
    equipmentStatus: string;
    isDuplicated: boolean;
    equipmentCategory: string;
    categoryList: Array<IListOption<string>>;
    equipmentTypeList: Array<IListOption<string>>;
    equipmentClassList: Array<IListOption<string>>;
}

export interface IListOption<TValue>
{
    label: string,
    value: TValue,
}

export interface IDropDownOption
{
    label: string;
    value: string;
}

export interface IFile
{
    name: string;
    path: string;
}

export enum EquipmentType
{
    AHU = 'AHU',
    CAV = 'CAV',
    VAV = 'VAV',
    SF = 'SF',
    EF = 'EF',
    TEF = 'TEF',
    PumpSet = 'PumpSet',
    Pump = 'Pump',
    PHE = 'PHE',
    ThermalStore = 'ThermalStore',
    HeatPump = 'HeatPump',
    Boiler = 'Boiler',
    Calorifier = 'Calorifier',
    Chiller = 'Chiller',
    CoolingTower = 'CoolingTower',
    PU = 'PU',
    FCU = 'FCU',
    AirCurtain = 'AirCurtain',
    TrenchHeater = 'TrenchHeater',
    Generator = 'Generator',
    CHP = 'CHP',
    UPS = 'UPS',
    Controller = 'Controller',
    ElectricMeter = 'ElectricMeter',
    ThermalMeter = 'ThermalMeter',
    GasMeter = 'GasMeter',
    WaterMeter = 'WaterMeter',
    FireExtinguisher = 'FireExtinguisher',
    CallPoint = 'CallPoint',
    SmokeDetector = 'SmokeDetector',
    HeatDetector = 'HeatDetector',
    VisualAndSounder = 'VisualAndSounder',
    FireAlarmPanel = 'FireAlarmPanel',
    OutdoorUnit = 'OutdoorUnit',
    IndoorUnit = 'IndoorUnit',
    PresentationAid = 'PresentationAid',
    HearingAid = 'HearingAid',
    DisplayScreen = 'DisplayScreen',
    CoffeeMachine = 'CoffeeMachine',
}

export enum EquipmentClass
{
    Ventilation = 'Ventilation',
    LTHW = 'LTHW',
    HWS = 'HWS',
    CHW = 'CHW',
    TerminalUnits = 'TerminalUnits',
    Electrical = 'Electrical',
    Controllers = 'Controllers',
    CWS = 'CWS',
    Meters = 'Meters',
    FireProtection = 'FireProtection',
    AC = 'AC',
    Workplace = 'Workplace',
}

export enum EquipmentCategory
{
    CapitalPlant = 'CapitalPlant',
    Workplace = 'Workplace',
}